import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get('CMS/api/FaqCategoriesQuery').then(r => {
        commit('setList', r.data.data);
      })
    },
    create({ commit, dispatch }, model) {
      return ajax.post('CMS/api/FaqCategories', model).then(r => {
      })
    },
    remove({ commit, dispatch }, id) {
      return ajax.delete('CMS/api/FaqCategories', { data: { "id": id } }, { headers: { 'Content-Type': 'application/json' } }).then(r => {
      })
    },
    update({ commit, dispatch }, model) {
      return ajax.put('CMS/api/FaqCategories', model).then(r => {
      })
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
}
